module.exports = __webpack_public_path__ + "assets/img/mecha-btn-5bd62d6b.png";